import { render, staticRenderFns } from "./BookingCalendarView.vue?vue&type=template&id=2350ec74&"
import script from "./BookingCalendarView.vue?vue&type=script&lang=js&"
export * from "./BookingCalendarView.vue?vue&type=script&lang=js&"
import style0 from "./BookingCalendarView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports